
  export const USER_DEVICES_RECEIVED = "USER_DEVICES_RECEIVED";
  export const SET_USER_DEVICE = "SET_USER_DEVICE";
  export const CREATE_USER_DEVICE = "CREATE_USER_DEVICE";
  export const SET_PROPERTY_USER_DEVICE = "SET_PROPERTY_USER_DEVICE";
  